import { PropuestasModule } from './../../../components/propuestas/propuestas.module';
import { AccionesPropuestaModule } from './../../../components/propuestas/acciones-propuesta/acciones-propuesta.module';
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import { BotonToggleModule } from "../../../components/boton/boton-toggle.module";
import { MaterialModule } from "../../../components/material/material.module";
import { TipoClienteModule } from "../../../forms/clientes/tipos-cliente/tipo-cliente.module";
import { VolverModule } from "../../../components/volver/volver.module";
import { ProspectosComponent } from "./prospectos.component";
import { ProspectosRoutingModule } from "./prospectos-routing.module";
import { ProspectoModule } from "../../../forms/prospectos/prospecto.module";
import { ProductoModule } from "../../../forms/productos/producto.module";
import { PipesModule } from '../../../pipes/pipes.module';

@NgModule({
  imports: [
    CommonModule,
    NgxPermissionsModule.forChild(),
    BotonToggleModule,
    MaterialModule,
    ProspectosRoutingModule,
    TipoClienteModule,
    VolverModule,
    ProspectoModule,
    ProductoModule,
    AccionesPropuestaModule,
    PropuestasModule,
    PipesModule
  ],
  declarations: [
    ProspectosComponent
  ],
  providers: [
  ],
  entryComponents: [
  ]
})
export class ProspectosModule { }
